module.exports = __webpack_public_path__ + "media/O’Shaughnessy- GPG House Section 2.319acbd1.mp3";